<template>
    <v-card variant="outlined">
        <v-card-title> PDF header details </v-card-title>
        <v-card-text>All inputs are optional</v-card-text>
        <v-card-text>
            <v-form>
                <v-container>
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-text-field
                                color="secondary"
                                v-model="author"
                                label="Author"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field
                                color="secondary"
                                v-model="jn"
                                label="Job number"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field
                                color="secondary"
                                v-model="jname"
                                label="Job title"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field
                                color="secondary"
                                v-model="rev"
                                label="Revision"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field
                                color="secondary"
                                v-model="cb"
                                label="Checked by"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field
                                color="secondary"
                                v-model="drgref"
                                label="Drawing reference"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field
                                color="secondary"
                                v-model="memloc"
                                label="Member location"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-select
                                color="secondary"
                                v-model="lang"
                                :items="langitems"
                                label="Header language"
                            ></v-select>
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-btn
                color="accent"
                type="submit"
                block
                @click.stop="genpdf()"
                :loading="loading"
                >Print</v-btn
            >
        </v-card-actions>
    </v-card>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

const props = defineProps({
    html: { required: true, type: String },
    calcname: { required: true, type: String },
})

const author = ref('')
const jn = ref('')
const jname = ref('')
const rev = ref('')
const cb = ref('')
const drgref = ref('')
const memloc = ref('')
const lang = ref('')
const langitems = ref([])
const loading = ref(false)

const user = computed(() => store.state.user)
const reportHeaders = computed(() => store.state.reportHeaders)

watch(
    reportHeaders,
    (newHeaders) => {
        updateForm(newHeaders)
    },
    { deep: true, immediate: true }
)

function updateForm(headers) {
    author.value = headers.author
    jn.value = headers.jn
    jname.value = headers.jname
    rev.value = headers.rev
    cb.value = headers.cb
    drgref.value = headers.drgref
    memloc.value = headers.memloc
    lang.value = headers.lang
    langitems.value = headers.langitems
}

async function genpdf() {
    loading.value = true
    store.commit('SET_REPORT_HEADERS', {
        author: author.value,
        jn: jn.value,
        jname: jname.value,
        rev: rev.value,
        cb: cb.value,
        drgref: drgref.value,
        memloc: memloc.value,
        lang: lang.value,
        langitems: langitems.value,
    })
    await store.dispatch('printPdf', {
        html: props.html,
        author: author.value,
        jname: jname.value,
        jn: jn.value,
        rev: rev.value,
        cb: cb.value,
        drgref: drgref.value,
        memloc: memloc.value,
        lang: lang.value,
        calcname: props.calcname,
    })
    loading.value = false
}
</script>
